import { useStyles } from './ChannelOfferCreationModal.styles'
import type { ReceivedResellerAuthorization } from '../../../modules/receivedResellerAuthorization/types'
import type { ValueCompProps } from './types'

export const getSelectedReceivedResellerAuth = (
  authorizations: ReceivedResellerAuthorization[] | undefined,
  selectedId: string | undefined
) => authorizations?.find(item => item?.id === selectedId)

export const ValueComp = ({ value }: ValueCompProps) => {
  const { classes } = useStyles()
  return <div className={classes.valueWrapper}>{value}</div>
}
